// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");

function container(alertCount, param) {
  var arg = function (param, param$1) {
    return BrowserStyle.withFont(param, param$1, /* Small */2, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
                  hd: BrowserStyle.alignItems("center"),
                  tl: {
                    hd: BrowserStyle.backgroundColor(param.backgroundColor),
                    tl: {
                      hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.75)),
                      tl: {
                        hd: BrowserStyle.color(param.textColor),
                        tl: {
                          hd: BrowserStyle.flexShrink(0.0),
                          tl: {
                            hd: BrowserStyle.height(BrowserStyle.rem(1.5)),
                            tl: {
                              hd: BrowserStyle.justifyContent("center"),
                              tl: {
                                hd: BrowserStyle.minWidth(BrowserStyle.rem(1.5)),
                                tl: {
                                  hd: BrowserStyle.padding2(BrowserStyle.zero, Curry._2(Relude_Int.OrdNamed.greaterThan, 99, alertCount) ? BrowserStyle.Spacing.xSmall : BrowserStyle.zero),
                                  tl: {
                                    hd: BrowserStyle.visibility(Curry._2(Relude_Int.OrdNamed.greaterThan, 0, alertCount) ? "visible" : "hidden"),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

var Styles = {
  container: container
};

function BrowserComponents_AlertCountIndicator(Props) {
  var alertCount = Props.alertCount;
  var themeOpt = Props.theme;
  var theme = themeOpt !== undefined ? themeOpt : ({
        backgroundColor: {
          TAG: /* Red */5,
          _0: /* Medium */2
        },
        textColor: {
          TAG: /* White */7,
          _0: /* Light */2
        }
      });
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: container(alertCount, theme),
              children: React.createElement(BrowserComponents_Text.make, {
                    children: Relude_Int.toString(alertCount)
                  })
            });
}

var make = BrowserComponents_AlertCountIndicator;

exports.Styles = Styles;
exports.make = make;
/* react Not a pure module */
